import { render, staticRenderFns } from "./RequestPerDayInAMonthBarChart.vue?vue&type=template&id=4d31d988&scoped=true&"
import script from "./RequestPerDayInAMonthBarChart.vue?vue&type=script&lang=js&"
export * from "./RequestPerDayInAMonthBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d31d988",
  null
  
)

export default component.exports